import React from 'react';

export const Arrow = ({ white, ...props }) => {
  return (
    <svg
      className='w-9 md:w-14'
      width='50'
      height='12'
      viewBox='0 0 50 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <g clipPath='url(#clip0)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M41.223 0V4.56122H0V6.4885H41.223V11.6279L50 5.65335L41.223 0Z'
          fill={white ? 'white' : 'black'}
        />
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='50' height='11.6279' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
